import styles from './_index.module.scss';

const VideoSurveyInstructions = () => {
  return (
    <div>
      <h3>Good to Know</h3>
      <ul className={styles['video-survey-instructions-list']}>
        <li>All panelists will complete this video on their mobile phone.</li>
        <li>
          Make sure your request is clear and concise and encourages an answer that is worth
          recording.
        </li>
        <li>
          Before recording their video, all panelists will see the instructional text shown below.
        </li>
      </ul>
      <br />
      <strong>Instructions For Panelists</strong>
      <p className={styles['video-survey-instructions-text']}>
        Please be as detailed as possible so we can fully understand your thoughts. Take a moment to
        consider your response, then record your video. Here are some tips for taking good videos:
      </p>
      <ul className={styles['video-survey-instructions-list']}>
        <li>Most videos should be about 30 seconds – 2 minutes.</li>
        <li>
          When recording a video, make sure the microphone is enabled on your device and avoid noisy
          environments (for example, turn off the radio or TV).
        </li>
        <li>
          Make sure you are connected to a strong and stable Wi-Fi connection so your videos upload
          easily.
        </li>
      </ul>
      <p className={styles['video-survey-instructions-text']}>
        <strong>Note:</strong> Please don’t upload any videos or photos that show the faces of
        children or anyone under 18. This is to help protect their privacy and safety online. If
        your uploads include videos or photos that show, or appear to show minors, we’ll remove your
        response, and you won’t be eligible for your incentive.
      </p>
    </div>
  );
};

export default VideoSurveyInstructions;
